// src/utils/transferWelcome.js
//
// The owner's dashboard invites them to complete the description of a
// facility an ambassador just handed over to them (transferred_at, from
// backend routes/showFacilityByEmailOwner.ts): while it has no description,
// for 30 days after the transfer, unless postponed this session.
export const DESCRIBE_INVITE_DAYS = 30;

export function facilityToDescribe(facilities, postponedIds = [], now = Date.now()) {
  return (facilities || []).find((f) => f?.transferred_at
    && now - new Date(f.transferred_at).getTime() < DESCRIBE_INVITE_DAYS * 86_400_000
    && !String(f.description || '').trim()
    && !postponedIds.includes(f.id)) ?? null;
}
